import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import * as themeConfig from "@store/theme/styleguide/config";
import merge from "lodash/merge";
import { css, DefaultTheme, ThemedCssFunction } from "styled-components";

let cachedTheme: BaseTheme;

export const polyfillCss: ThemedCssFunction<DefaultTheme> = (first: any, ...interpolations: any) => {
    let theme: BaseTheme = cachedTheme;

    if (!cachedTheme) {
        const { postStyleGuideTheme } = require("@insite/client-framework/ThemeConfiguration"); // eslint-disable-line
        const isInitialized = Object.keys(postStyleGuideTheme).length > 0;
        theme = merge({}, baseTheme, isInitialized ? postStyleGuideTheme : themeConfig);

        if (isInitialized) {
            cachedTheme = theme;
        }
    }

    return css(
        {},
        css(first, ...interpolations)
            .map(x => (typeof x === "function" ? (x as any)({ theme }) : x))
            .join(""),
    );
};
